import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { BiPencil } from "react-icons/bi";
import  DeleteConfirmDialog  from './DeleteConfirmDialog';
import { axiosAuth_DATA_MGMT_API, axiosAuth_PLATFORM_API } from '../utils/AxoisUtilComponent';
import { useTranslation } from 'react-i18next';
import classes from './AdminPages.module.css';
import './AdminPages.css';
import { translateAPIError } from '../utils/apiUtils';
import { formatDate } from '../utils/timeUtils';


const BatchDataProcAdminDetailsView = (props) => {

  // Utilities
  const { t } = useTranslation(['common', 'custom']);
  const navigate = useNavigate();

  const [objAttrs,          setObjAttrs]          = useState({});
  const [entityList,        setEntityList]        = useState();

  const [errMsg,            setErrMsg]            = useState('');

  // UI Functions

  // Initialize state
  useEffect(() => {
    if (props) {
      fetchObj(props.objDetails.id);
    }

    fetchBatchProcEntities();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const fetchObj = (id) => {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.get("batch-data-proc-reqs/" + id);

        resolve(res.data);

        if (res.status === 200) {
          setObjAttrs(res.data[0]);
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }


  const fetchBatchProcEntities = async () => {
      
    try {
      const res = await axiosAuth_PLATFORM_API.get("business-configs?name=BATCH_PROC_ENTITIES");
      
      if (!res.data || (res.data.length === 0) || !res.data[0].config || (res.data[0].config.length === 0)) {
        setErrMsg(t("I18N_No_search_result"));
      } else {
        setEntityList(res.data[0].config);
        setErrMsg('');
      }
    
    } catch (error) {
      if (!error.message || (error.message !== 'IGNORE')) {
        setErrMsg(t(translateAPIError(error)));
      }
    }
  };


  const handleClose = (e) => {
    e.preventDefault();

    // Return to list
    navigate(-1);
  }


  // --- Edit Comments ---
  const [updatedAttrs,              setUpdatedAttrs]              = useState(null);
  const [showEditCommentsDialog,    setShowEditCommentsDialog]    = useState(false);
  const [errMsg_EditCommentsDialog, setErrMsg_EditCommentsDialog] = useState('');

  function handleEditComments() {
    setUpdatedAttrs({targetEntity: objAttrs.targetEntity,
                     comments:     objAttrs.comments,
                     filter:       objAttrs.filter});
    setShowEditCommentsDialog(true);
  }

  const onInputChange = (e) => {
    setUpdatedAttrs({ ...updatedAttrs, [e.target.name]: e.target.value })
  }

  function handleEditCommentsDialogCancel() {

    setUpdatedAttrs(null);
    setErrMsg_EditCommentsDialog('');
    setShowEditCommentsDialog(false);
  }

  function handleEditCommentsDialogSubmit() {

    // Validation
    if (updatedAttrs.comments && (updatedAttrs.comments.length > 250)) {
      setErrMsg_EditCommentsDialog(t('I18N_ERR_Max_len_comments') + 250);
      return;
    }

    return new Promise(async (resolve, reject) => {
      try {
        let reqBody = {
              targetEntity: updatedAttrs.targetEntity,
              comments:     updatedAttrs.comments,
              filter:       updatedAttrs.filter
            }

        const res = await axiosAuth_DATA_MGMT_API.put("batch-data-proc-reqs/" + objAttrs.id, reqBody);

        resolve(res.data);

        if (res.status === 200) {
          setErrMsg_EditCommentsDialog('');
          setShowEditCommentsDialog(false);

          setUpdatedAttrs(null);

          // Update list
          fetchObj(props.objDetails.id);
        }

      } catch (error) {
        if (!error.message || (error.message !== 'IGNORE')) {
          setErrMsg_EditCommentsDialog(t(translateAPIError(error)));
        }
      }

    });

  }


  // --- Cancel Request ---

  const [showCancelConfirmDialog, setShowCancelConfirmDialog] = useState(false);
  const [errMsgDeleteConfirm,     setErrMsgDeleteConfirm]     = useState('')

  const handleCancelReq = () => {
    setShowCancelConfirmDialog(true);
  }

  function handleCancelReqCancel() {
    setShowCancelConfirmDialog(false);
  }

  function handleCancelReqSubmit() {

    return new Promise(async (resolve, reject) => {
      try {
        const res = await axiosAuth_DATA_MGMT_API.post("batch-data-proc-reqs/" + props.objDetails.id + "/cancel");

        resolve(res.data);

        if (res.status === 200) {

          // Restore UI to viewing mode
          setShowCancelConfirmDialog(false);
          setErrMsgDeleteConfirm('');

          fetchObj(props.objDetails.id);
        }

      } catch (error) {
        setErrMsgDeleteConfirm(t(translateAPIError(error)));
      }
    });
  }


  // --- Download data ---

  const handleDownloadData = (id, downloadType, fileName) => {

    let apiPath = "batch-data-proc-reqs/" + id + "/file?type=" + downloadType;

    return new Promise(async (resolve, reject) => {
      try {

        const res = await axiosAuth_DATA_MGMT_API.get(apiPath, {responseType: "arraybuffer"});

        resolve(res.data);

        if (res.status === 200) {

          // Convert HEX data to binary
          const blob = new Blob([new Uint8Array(res.data)], { type: 'text/csv' });
          const blobUrl = URL.createObjectURL(blob);

          const link = document.createElement('a')

          link.href = blobUrl;
          link.download = "" + fileName + "";
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }

        setErrMsg('');
      } catch (error) {
        setErrMsg(t(translateAPIError(error)));
      }
    });
  }



  return (
    <>

      <Card style={{overflow:'auto', border:'0', boxShadow:'0 2px 2px 0px rgba(0,0,0,0.1)',
                    padding:'20px 40px 20px 40px', maxWidth:'2500px', width:'100%', fontSize:'13px'}}>

        <div style={{display:'flex'}}>
          <span className={classes.admin_pages__page_title}>
            {t("I18N_Batch_Data_Proc_Req_Details")}
          </span>
        </div>

        <div className={classes.admin_pages__page_subtitle} style={{marginTop:'20px'}}>
          <div display='flex'>
            <span>
              {t("I18N_Req_info")}
            </span>
          </div>
          <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

          <Container>
            <form>
              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Req_id")}:</Col>
                <Col sm={3}>{t("I18N_Target_entity")}:</Col>
                <Col sm={3}>{t("I18N_Operation")}:</Col>
                { (props.objDetails.operation === 'INSERT') ||  (props.objDetails.operation === 'UPDATE') ||  (props.objDetails.operation === 'DELETE') ?
                    <Col sm={3}>
                      <span>{t("I18N_File_name")}:</span>
                    </Col>
                  : null
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.id}</Col>
                <Col sm={3} style={{overflowWrap:'anywhere'}}>
                  { entityList && objAttrs.targetEntity ?
                      (entityList.find( ({ code }) => code === objAttrs.targetEntity )).name
                    : null
                  }
                </Col>
                <Col sm={3} style={{overflowWrap:'anywhere'}}>{t("I18N_" + objAttrs.operation)}</Col>
                { (props.objDetails.operation === 'INSERT') ||  (props.objDetails.operation === 'UPDATE') ||  (props.objDetails.operation === 'DELETE') ?
                    <Col sm={3}>
                      <span>{objAttrs.fileName}</span>
                    </Col>
                  : null
                }
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={6}>
                  <span>{t("I18N_Comments")}:</span>
                  <span style={{marginLeft:'15px', fontSize:'9px', color:'SteelBlue', cursor:'pointer'}} onClick={handleEditComments}>
                    <BiPencil size={16} />
                    {t("I18N_Edit")}
                  </span>
                </Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={6} style={{overflowWrap:'anywhere'}}>{objAttrs.comments}</Col>
              </Row>

              { ((props.objDetails.operation === 'INSERT') ||  (props.objDetails.operation === 'UPDATE') ||  (props.objDetails.operation === 'DELETE'))
                && ((objAttrs.status === 'SUCCESS') || (objAttrs.status === 'FAILED')) ?
                  <>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                      <Col sm={3}>{t("I18N_Start_time")}:</Col>
                      <Col sm={3}>{t("I18N_Finish_time")}:</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col sm={3}>{formatDate(objAttrs.startTime)}</Col>
                      <Col sm={3}>{formatDate(objAttrs.finishTime)}</Col>
                    </Row>
                  </>
              : (props.objDetails.operation === 'EXPORT') && (objAttrs.status === 'SUCCESS') ?
                  <>
                    <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                      <Col sm={3}>{t("I18N_Row_count")}:</Col>
                      <Col sm={3}>{t("I18N_Start_time")}:</Col>
                      <Col sm={3}>{t("I18N_Finish_time")}:</Col>
                    </Row>
                    <Row className={classes.admin_pages__field_value}>
                      <Col sm={3}>{objAttrs.rowCount}</Col>
                      <Col sm={3}>{formatDate(objAttrs.startTime)}</Col>
                      <Col sm={3}>{formatDate(objAttrs.finishTime)}</Col>
                    </Row>
                  </>
              : null
              }

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Status")}:</Col>
                { (objAttrs.error !== null) ?
                  <Col sm={3}>{t("I18N_Error")}:</Col>
                  : null
                }
                <Col sm={3}>{t("I18N_Status_time")}:</Col>
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3} style={{color: (objAttrs.status === 'SUCCESS' ? 'green' :
                                            objAttrs.status === 'FAILED'  ? 'red' :
                                            'steelblue')
                                  }}>
                  {t("I18N_" + objAttrs.status)}
                </Col>
                { (objAttrs.error !== null) ?
                  <Col sm={3} style={{color: 'red'}}>{t("I18N_" + objAttrs.error)}</Col>
                  : null
                }
                <Col sm={3}>{formatDate(objAttrs.statusTime)}</Col>
              </Row>

              <Row className={classes.admin_pages__field_label} style={{ marginTop: '10px' }}>
                <Col sm={3}>{t("I18N_Requester")}:</Col>
                <Col sm={3}>{t("I18N_Request_time")}:</Col>
                { (objAttrs.status === 'CANCELLED') ?
                  <>
                    <Col sm={3}>{t("I18N_Cancelled_by")}:</Col>
                    <Col sm={3}>{t("I18N_Cancel_time")}:</Col>
                  </>
                :
                  <>
                    <Col sm={3}>{t("I18N_Updated_by")}:</Col>
                    <Col sm={3}>{t("I18N_Time_updated")}:</Col>
                  </>
                }
              </Row>
              <Row className={classes.admin_pages__field_value}>
                <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.creatorUsername}</Col>
                <Col sm={3} style={{overflowWrap:'anywhere'}}>{formatDate(objAttrs.timeCreated)}</Col>
                { (objAttrs.status === 'CANCELLED') ?
                  <>
                    <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.cancelUsername}</Col>
                    <Col sm={3} style={{overflowWrap:'anywhere'}}>{formatDate(objAttrs.cancelTime)}</Col>
                  </>
                :
                  <>
                    <Col sm={3} style={{overflowWrap:'anywhere'}}>{objAttrs.updaterUsername}</Col>
                    <Col sm={3} style={{overflowWrap:'anywhere'}}>{formatDate(objAttrs.timeUpdated)}</Col>
                  </>
                }
              </Row>

            </form>
          </Container>
        </div>

        <hr className="solid" style={{ marginTop: '30px' }}></hr>

        <div className={classes.admin_pages__page_subtitle} >
          <Form.Group as={Row} className="mb-2 mt-3">
            <div style={{ display: "flex" }}>
              <Button size="sm" variant="outline-secondary" className="mb-3"
                style={{ fontSize: '12px', fontWeight: '300' }}
                onClick={handleClose}>
                {t("I18N_Close")}
              </Button>

              { objAttrs.status === 'PENDING' ?
                <Button size="sm" variant="outline-secondary" className="mb-3"
                  style={{ marginLeft: '10px', fontSize: '12px', fontWeight: '300' }}
                  onClick={handleCancelReq}>
                  {t("I18N_Cancel_req")}
                </Button>
              : null
              }

              { (props.objDetails.operation === 'INSERT') ||  (props.objDetails.operation === 'UPDATE') ||
                (props.objDetails.operation === 'DELETE') ?

                  ((objAttrs.status === 'SUCCESS') && (props.objDetails.operation === 'INSERT')) ?
                    <>
                    {(props.objDetails.impResultUrl !== null) ?
                      <Button size="sm" variant="outline-secondary" className="mb-3"
                              style={{ marginLeft: '10px', fontSize: '12px', fontWeight: '300' }}
                              onClick={() => handleDownloadData(
                                               props.objDetails.id, 'imp-result',
                                               (props.objDetails.impResultUrl).slice((props.objDetails.impResultUrl).lastIndexOf('/') + 1))} >
                       {t("I18N_TIP_Download_imp_data_w_id")}
                      </Button>
                    :
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'20px', marginTop:'5px'}}>
                        {t("I18N_Note") + ": " + t("I18N_Imp_result_expired")}
                      </span>
                    }
                    </>
                  : (objAttrs.status === 'FAILED') ?
                    <>
                    {((props.objDetails.errReportUrl !== null) && (props.objDetails.error === 'ERR_See_err_report')) ?
                      <Button size="sm" variant="outline-secondary" className="mb-3"
                              style={{ marginLeft: '10px', fontSize: '12px', fontWeight: '300' }}
                              onClick={() => handleDownloadData(
                                             props.objDetails.id, 'error-report',
                                             (props.objDetails.errReportUrl).slice((props.objDetails.errReportUrl).lastIndexOf('/') + 1))}>
                       {t("I18N_TIP_Download_err_rpt")}
                      </Button>
                    : ((props.objDetails.errReportUrl === null) && (props.objDetails.error === 'ERR_See_err_report')) ?
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'20px', marginTop:'5px'}}>
                        {t("I18N_Note") + ": " + t("I18N_Err_report_expired")}
                      </span>
                    : null
                    }
                    </>
                  : null
                :
                  (objAttrs.status === 'SUCCESS') ?
                    (props.objDetails.expOutputUrl !== null) ?
                      <Button size="sm" variant="outline-secondary" className="mb-3"
                              style={{ marginLeft: '10px', fontSize: '12px', fontWeight: '300' }}
                              onClick={() => handleDownloadData(
                                               props.objDetails.id, 'exp-output',
                                               (props.objDetails.expOutputUrl).slice((props.objDetails.expOutputUrl).lastIndexOf('/') + 1))}>
                       {t("I18N_TIP_Download_exp_data")}
                      </Button>
                    :
                      <span className={classes.admin_pages__field_label} style={{marginLeft:'20px', marginTop:'5px'}}>
                        {t("I18N_Note") + ": " + t("I18N_Exp_output_expired")}
                      </span>
                  : null
              }

              <span className={classes.admin_pages__field_label} style={{marginLeft:'30px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                {errMsg}
              </span>
            </div>
          </Form.Group>
        </div>


        <Modal show={showEditCommentsDialog} onHide={handleEditCommentsDialogCancel} centered >
          <Modal.Body>
            <div className={classes.admin_pages__page_subtitle} style={{marginTop:'0px'}}>
              <span> {t("I18N_Edit_comments")} </span>

              <hr className="solid" style={{ margin: '0 0 10px 0' }}></hr>

              <Row className={classes.admin_pages__field_value}>
                <Col>
                  <textarea className={classes.admin_pages__field_editable} style={{width:'100%'}} name="comments"
                    value={updatedAttrs && updatedAttrs.comments ? updatedAttrs.comments : ''}
                    onChange={(e) => onInputChange(e)} />
                </Col>
              </Row>

              <Row>
                <span className={classes.admin_pages__field_label} style={{marginTop:'5px', color:'rgba(200,0,0)', verticalAlign:'top'}}>
                  {errMsg_EditCommentsDialog}
                </span>
              </Row>

              <Row>
                <div display='flex' style={{marginTop:'15px'}}>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ float: 'left' }}
                    onClick={handleEditCommentsDialogCancel}>
                    {t("I18N_Cancel")}
                  </Button>
                  <Button size="tiny" variant="outline-secondary" className="mb-3"
                    style={{ marginLeft: '10px' }}
                    onClick={handleEditCommentsDialogSubmit}>
                    {t("I18N_Submit")}
                  </Button>
                </div>
              </Row>

            </div>
          </Modal.Body>
        </Modal>


        <DeleteConfirmDialog
          title={t("I18N_Req_cancel_confirm")}
          show={showCancelConfirmDialog}
          targetName={t("I18N_Req_id") + ": " + (props.objDetails ? props.objDetails.id : '')}
          errMsgDeleteConfirm={errMsgDeleteConfirm}
          onCancel={handleCancelReqCancel}
          onSubmit={handleCancelReqSubmit}
        />

      </Card>
    </>
  );

}

export default BatchDataProcAdminDetailsView;
